module.exports = __webpack_public_path__ + "img/animation.09704cd3.gif";